export const routeNames = {
  apb: 'apb',
  apbPractices: 'apb-practices',
  apbProcessedEmailDetails: 'apb-processed-email-details',
  apbProcessedEmails: 'apb-processed-emails',
  caseCreation: 'case-creation',
  caseDetails: 'case-details',
  caseDetailsEvents: 'case-details-events',
  caseDetailsRecordCreation: 'case-details-record-creation',
  caseDetailsRecords: 'case-details-records',
  caseDetailsSubjectDetails: 'case-details-subject-details',
  caseDetailsSubjectRecordCreation: 'case-details-subject-record-creation',
  caseDetailsSubjectRecords: 'case-details-subject-records',
  caseDetailsSubjects: 'case-details-subjects',
  caseEdit: 'case-edit',
  cases: 'cases',
  caseSubjectCreation: 'case-subject-creation',
  courtCreation: 'court-creation',
  courtEdit: 'court-edit',
  courts: 'courts',
  deadlineBadges: 'deadline-badges',
  deadlineCreation: 'deadline-creation',
  deadlineEdit: 'deadline-edit',
  deadlines: 'deadlines',
  emailCampaignDetails: 'email-campaign-details',
  emailCampaigns: 'email-campaigns',
  firstPasswordChange: 'first-password-change',
  home: 'home',
  homeLayout: 'home-layout',
  login: 'login',
  massiveEmailCreation: 'massive-email-creation',
  massiveEmailDetails: 'massive-email-details',
  massiveEmailDetailsEvents: 'massive-email-details-events',
  massiveEmailDetailsMetadata: 'massive-email-details-metadata',
  massiveEmailDetailsPreview: 'massive-email-details-preview',
  massiveEmailDetailsReceivers: 'massive-email-details-receivers',
  massiveEmailDetailsReceiversCreation: 'massive-email-details-receivers-creation',
  massiveEmailDetailsResponses: 'massive-email-details-responses',
  massiveEmailEdit: 'massive-email-edit',
  massiveEmails: 'massive-emails',
  massiveEmailTypes: 'massive-email-types',
  massiveImports: 'massive-imports',
  notFound: 'not-found',
  pctDepositAddParty: 'pct-deposit-add-party',
  pctDepositCreation: 'pct-deposit-creation',
  pctDepositDetails: 'pct-deposit-details',
  pctDepositParties: 'pct-deposit-parties',
  pctDeposits: 'pct-deposits',
  pctEvents: 'pct-events',
  personCreation: 'person-creation',
  personDetails: 'person-details',
  personEdit: 'person-edit',
  personLinkCreation: 'person-link-creation',
  personLinks: 'person-links',
  personMerge: 'person-merge',
  persons: 'persons',
  portfolios: 'portfolios',
  practiceCreation: 'practice-creation',
  practiceDetails: 'practice-details',
  practiceDetailsDeadlineDetails: 'practice-details-deadline-details',
  practiceDetailsDeadlines: 'practice-details-deadlines',
  practiceDetailsEvents: 'practice-details-events',
  practiceDetailsPctEvents: 'practice-details-pct-events',
  practiceDetailsRecordCreation: 'practice-details-record-creation',
  practiceDetailsRecords: 'practice-details-records',
  practiceDetailsRedirecter: 'practice-details-redirecter',
  practiceDetailsSubjectDetails: 'practice-details-subject-details',
  practiceDetailsSubjectRecordCreation: 'practice-details-subject-record-creation',
  practiceDetailsSubjectRecords: 'practice-details-subject-records',
  practiceDetailsSubjects: 'practice-details-subjects',
  practiceDetailsTaskDetails: 'practice-details-task-details',
  practiceDetailsTasks: 'practice-details-tasks',
  practiceEdit: 'practice-edit',
  practiceEditCase: 'practice-edit-case',
  practiceEditRelations: 'practice-edit-relations',
  practicePhaseCreation: 'practice-phase-creation',
  practicePhaseEdit: 'practice-phase-edit',
  practicePhases: 'practice-phases',
  practices: 'practices',
  practiceSubjectCreation: 'practice-subject-creation',
  practiceTypeAssignmentRoles: 'practice-type-assignment-roles',
  practiceTypeCreation: 'practice-type-creation',
  practiceTypeDeadlineTypes: 'practice-type-deadline-types',
  practiceTypeDetails: 'practice-type-details',
  practiceTypeEdit: 'practice-type-edit',
  practiceTypeRecordTools: 'practice-type-record-tools',
  practiceTypeRecordTypes: 'practice-type-record-types',
  practiceTypes: 'practice-types',
  practiceWithCaseCreation: 'practice-with-case-creation',
  profile: 'profile',
  recordTypeCreation: 'record-types-creation',
  recordTypeDetails: 'record-types-details',
  recordTypeEdit: 'record-types-edit',
  recordTypeFieldCreation: 'record-type-field-creation',
  recordTypeFieldEdit: 'record-type-field-edit',
  recordTypeFields: 'record-types-fields',
  recordTypes: 'record-types',
  recordTypesCaseRecords: 'record-types-case-records',
  reports: 'reports',
  roleCreation: 'role-creation',
  roleEdit: 'role-edit',
  roles: 'roles',
  settings: 'settings',
  subjectTypeCreation: 'subject-types-creation',
  subjectTypeDetails: 'subject-types-details',
  subjectTypeEdit: 'subject-types-edit',
  subjectTypes: 'subject-types',
  taskCreation: 'task-types-creation',
  taskDetails: 'task-details',
  tasks: 'tasks',
  taskTypeCreation: 'task-types-creation',
  taskTypeDetails: 'task-types-details',
  taskTypeEdit: 'task-types-edit',
  taskTypes: 'task-types',
  toolRunCreation: 'tool-run-creation',
  toolRunDetails: 'tool-run-details',
  toolRuns: 'tool-runs',
  unauthorized: 'unauthorized',
  userCreation: 'user-creation',
  userEdit: 'edit-user',
  users: 'users',
} as const

export type RouteNameKey = keyof typeof routeNames
export type RouteName = (typeof routeNames)[RouteNameKey]

export const isRouteName = (value: unknown): value is RouteName => {
  return Object.values(routeNames).includes(value as RouteName)
}

const uuidRegex = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
const customId = (idName: string) => `/:${idName}(${uuidRegex})`
const id = customId('id')
const index = '/:index([0-9]+)'
const edit = '/edit'
const merge = '/merge'
const creation = '/new'

const any = '/:any(.*)'
const home = '/'
const profile = '/profile'
const unauthorized = '/unauthorized'
const login = '/login'
const firstPasswordChange = '/first-password-change'
const events = '/events'
const specificFields = '/specific-fields'
const assignmentRoles = '/assignment-roles'
const metadata = '/metadata'
const preview = '/preview'
const links = '/links'
const relations = '/relations'
const processedEmails = '/processed-emails'
const badges = '/badges'

const domainPrefixes = {
  apb: '/apb',
  auth: '/auth',
  caseRecordTypes: '/case-record-types',
  cases: '/cases',
  courts: '/courts',
  deadlines: '/deadlines',
  deadlineTypes: '/deadline-types',
  details: '/details',
  emailCampaigns: '/email-campaigns',
  massiveEmails: '/massive-emails',
  massiveEmailTypes: '/massive-email-types',
  massiveImports: '/massive-imports',
  parties: '/parties',
  pctDeposits: '/pct-deposits',
  pctEvents: '/pct-events',
  persons: '/persons',
  portfolios: '/portfolios',
  practicePhases: '/practice-phases',
  practices: '/practices',
  practiceTypes: '/practice-types',
  receivers: '/receivers',
  records: '/records',
  recordTools: '/record-tools',
  recordTypes: '/record-types',
  reports: '/reports',
  responses: '/responses',
  roles: '/roles',
  settings: '/settings',
  subjects: '/subjects',
  subjectTypes: '/subject-types',
  tasks: '/tasks',
  taskTypes: '/task-types',
  toolRuns: '/tool-runs',
  users: '/users',
}

const practiceRoute = domainPrefixes.cases + customId('caseId') + domainPrefixes.practices + id
const practiceSubjectRoute = practiceRoute + domainPrefixes.subjects + customId('subjectId')
const caseSubjectRoute = domainPrefixes.cases + id + domainPrefixes.subjects + customId('subjectId')

export const routePaths: Record<RouteNameKey, string> = {
  apb: domainPrefixes.apb,
  apbPractices: domainPrefixes.apb + domainPrefixes.practices,
  apbProcessedEmailDetails: domainPrefixes.apb + processedEmails + id,
  apbProcessedEmails: domainPrefixes.apb + processedEmails,
  caseCreation: domainPrefixes.cases + creation,
  caseDetails: domainPrefixes.cases + id,
  caseDetailsEvents: domainPrefixes.cases + id + events,
  caseDetailsRecordCreation: domainPrefixes.cases + id + domainPrefixes.records + creation,
  caseDetailsRecords: domainPrefixes.cases + id + domainPrefixes.records,
  caseDetailsSubjectDetails: caseSubjectRoute,
  caseDetailsSubjectRecordCreation: caseSubjectRoute + domainPrefixes.records + creation,
  caseDetailsSubjectRecords: caseSubjectRoute + domainPrefixes.records,
  caseDetailsSubjects: domainPrefixes.cases + id + domainPrefixes.subjects,
  caseEdit: domainPrefixes.cases + id + edit,
  cases: domainPrefixes.cases,
  caseSubjectCreation: domainPrefixes.cases + id + domainPrefixes.subjects + creation,
  courtCreation: domainPrefixes.courts + creation,
  courtEdit: domainPrefixes.courts + id + edit,
  courts: domainPrefixes.courts,
  deadlineBadges: domainPrefixes.deadlines + badges,
  deadlineCreation: practiceRoute + domainPrefixes.deadlines + creation,
  deadlineEdit: practiceRoute + domainPrefixes.deadlines + customId('deadlineId') + edit,
  deadlines: domainPrefixes.deadlines,
  emailCampaignDetails: domainPrefixes.emailCampaigns + id,
  emailCampaigns: domainPrefixes.emailCampaigns,
  firstPasswordChange: domainPrefixes.auth + firstPasswordChange,
  home: home,
  homeLayout: home,
  login: domainPrefixes.auth + login,
  massiveEmailCreation: domainPrefixes.massiveEmails + creation,
  massiveEmailDetails: domainPrefixes.massiveEmails + id,
  massiveEmailDetailsEvents: domainPrefixes.massiveEmails + id + events,
  massiveEmailDetailsMetadata: domainPrefixes.massiveEmails + id + metadata,
  massiveEmailDetailsPreview: domainPrefixes.massiveEmails + id + preview,
  massiveEmailDetailsReceivers: domainPrefixes.massiveEmails + id + domainPrefixes.receivers,
  massiveEmailDetailsReceiversCreation: domainPrefixes.massiveEmails + id + domainPrefixes.receivers + creation,
  massiveEmailDetailsResponses: domainPrefixes.massiveEmails + id + domainPrefixes.responses,
  massiveEmailEdit: domainPrefixes.massiveEmails + id + edit,
  massiveEmails: domainPrefixes.massiveEmails,
  massiveEmailTypes: domainPrefixes.massiveEmailTypes,
  massiveImports: domainPrefixes.massiveImports,
  notFound: any,
  pctDepositAddParty: domainPrefixes.pctDeposits + id + domainPrefixes.parties + creation,
  pctDepositCreation: domainPrefixes.pctDeposits + creation,
  pctDepositDetails: domainPrefixes.pctDeposits + id,
  pctDepositParties: domainPrefixes.pctDeposits + id + domainPrefixes.parties,
  pctDeposits: domainPrefixes.pctDeposits,
  pctEvents: domainPrefixes.pctEvents,
  personCreation: domainPrefixes.persons + creation,
  personDetails: domainPrefixes.persons + id,
  personEdit: domainPrefixes.persons + id + edit,
  personLinkCreation: domainPrefixes.persons + id + links + creation,
  personLinks: domainPrefixes.persons + id + links,
  personMerge: domainPrefixes.persons + id + merge,
  persons: domainPrefixes.persons,
  portfolios: domainPrefixes.portfolios,
  practiceCreation: domainPrefixes.cases + id + domainPrefixes.practices + creation,
  practiceDetails: practiceRoute,
  practiceDetailsDeadlineDetails: practiceRoute + domainPrefixes.deadlines + customId('deadlineId'),
  practiceDetailsDeadlines: practiceRoute + domainPrefixes.deadlines,
  practiceDetailsEvents: practiceRoute + events,
  practiceDetailsPctEvents: practiceRoute + domainPrefixes.pctEvents,
  practiceDetailsRecordCreation: practiceRoute + domainPrefixes.records + creation,
  practiceDetailsRecords: practiceRoute + domainPrefixes.records,
  practiceDetailsRedirecter: domainPrefixes.practices + id,
  practiceDetailsSubjectDetails: practiceSubjectRoute,
  practiceDetailsSubjectRecordCreation: practiceSubjectRoute + domainPrefixes.records + creation,
  practiceDetailsSubjectRecords: practiceSubjectRoute + domainPrefixes.records,
  practiceDetailsSubjects: practiceRoute + domainPrefixes.subjects,
  practiceDetailsTaskDetails: practiceRoute + domainPrefixes.tasks + customId('taskId'),
  practiceDetailsTasks: practiceRoute + domainPrefixes.tasks,
  practiceEdit: practiceRoute + edit,
  practiceEditCase: practiceRoute + edit + domainPrefixes.cases,
  practiceEditRelations: practiceRoute + edit + relations,
  practicePhaseCreation: domainPrefixes.practiceTypes + id + domainPrefixes.practicePhases + creation,
  practicePhaseEdit: domainPrefixes.practiceTypes + id + domainPrefixes.practicePhases + customId('phaseId') + edit,
  practicePhases: domainPrefixes.practiceTypes + id + domainPrefixes.practicePhases,
  practices: domainPrefixes.practices,
  practiceSubjectCreation: practiceRoute + domainPrefixes.subjects + creation,
  practiceTypeAssignmentRoles: domainPrefixes.practiceTypes + id + assignmentRoles,
  practiceTypeCreation: domainPrefixes.practiceTypes + creation,
  practiceTypeDeadlineTypes: domainPrefixes.practiceTypes + id + domainPrefixes.deadlineTypes,
  practiceTypeDetails: domainPrefixes.practiceTypes + id,
  practiceTypeEdit: domainPrefixes.practiceTypes + id + edit,
  practiceTypeRecordTools: domainPrefixes.practiceTypes + id + domainPrefixes.recordTools,
  practiceTypeRecordTypes: domainPrefixes.practiceTypes + id + domainPrefixes.recordTypes,
  practiceTypes: domainPrefixes.practiceTypes,
  practiceWithCaseCreation: domainPrefixes.practices + creation,
  profile: profile,
  recordTypeCreation: domainPrefixes.recordTypes + creation,
  recordTypeDetails: domainPrefixes.recordTypes + id,
  recordTypeEdit: domainPrefixes.recordTypes + id + edit,
  recordTypeFieldCreation: domainPrefixes.recordTypes + id + specificFields + creation,
  recordTypeFieldEdit: domainPrefixes.recordTypes + id + specificFields + index + edit,
  recordTypeFields: domainPrefixes.recordTypes + id + specificFields,
  recordTypes: domainPrefixes.recordTypes,
  recordTypesCaseRecords: domainPrefixes.recordTypes + domainPrefixes.caseRecordTypes,
  reports: domainPrefixes.reports,
  roleCreation: domainPrefixes.roles + creation,
  roleEdit: domainPrefixes.roles + id + edit,
  roles: domainPrefixes.roles,
  settings: domainPrefixes.settings,
  subjectTypeCreation: domainPrefixes.subjectTypes + creation,
  subjectTypeDetails: domainPrefixes.subjectTypes + id,
  subjectTypeEdit: domainPrefixes.subjectTypes + id + edit,
  subjectTypes: domainPrefixes.subjectTypes,
  taskCreation: domainPrefixes.tasks + creation,
  taskDetails: domainPrefixes.tasks + id,
  tasks: domainPrefixes.tasks,
  taskTypeCreation: domainPrefixes.taskTypes + creation,
  taskTypeDetails: domainPrefixes.taskTypes + id,
  taskTypeEdit: domainPrefixes.taskTypes + id + edit,
  taskTypes: domainPrefixes.taskTypes,
  toolRunCreation: domainPrefixes.toolRuns + creation,
  toolRunDetails: domainPrefixes.toolRuns + id,
  toolRuns: domainPrefixes.toolRuns,
  unauthorized: unauthorized,
  userCreation: domainPrefixes.users + creation,
  userEdit: domainPrefixes.users + id + edit,
  users: domainPrefixes.users,
}

export const routeAlias: Partial<Record<RouteNameKey, string[]>> = {
  caseDetails: [domainPrefixes.cases + id + domainPrefixes.practices],
  courtEdit: [domainPrefixes.courts + id],
  homeLayout: ['/home'],
  login: [login, domainPrefixes.auth],
  practicePhaseEdit: [domainPrefixes.practiceTypes + id + domainPrefixes.practicePhases + customId('phaseId')],
  recordTypeFieldEdit: [domainPrefixes.recordTypes + id + specificFields + index],
  roleEdit: [domainPrefixes.roles + id],
  userEdit: [domainPrefixes.users + id],
}
